var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('staff-search-filters'),_vm._v(" "),_c('staff-search-top'),_vm._v(" "),_c('staff-list',{attrs:{"location-link":_vm.locationLink}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }